import styled from '@emotion/styled';

export const Button = styled.button`
  display: inline-flex;
  margin: 8px;
`;
